import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-alert-config-data-hdld',
  templateUrl: './alert-config-data-hdld.component.html',
  styles: [`
    .color-confirm: {
      color: #2D3036; 
      font-weight: 500 !important
    }
  `]
})
export class AlertConfigDataHDLDComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<AlertConfigDataHDLDComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = false;
  }

  ngOnInit() {
  }

  closeDialog(){
    this.dialogRef.close();
  }

  onNoClick() {
    this.dialogRef.close(false);
  }

  handleAccept(){
    this.dialogRef.close(true);
  }
}
